export const LayoutContainerProperty = {
  Spacing: 'spacing',
};

export default {
  LayoutContainerProperty,
};
